/**
 * Component: sa-faq-drawer
 * Description: Renders a list of FAQ titles; clicking opens a right-side drawer with content
 */
(function () {
  if (customElements.get('sa-faq-drawer')) return;

  class SaFaqDrawer extends HTMLElement {
    constructor() {
      super();
      this.onItemClick = this.onItemClick.bind(this);
      this.onCloseClick = this.onCloseClick.bind(this);
      this.onOverlayClick = this.onOverlayClick.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);
    }

    connectedCallback() {
      // 1. Query elements BEFORE moving them to body
      this.overlay = this.querySelector('.sa-faq-drawer__overlay');
      this.panel = this.querySelector('.sa-faq-drawer__panel');
      
      // Query children inside the panel
      if (this.panel) {
        this.titleEl = this.panel.querySelector('.sa-faq-drawer__panel-title');
        this.contentEl = this.panel.querySelector('.sa-faq-drawer__panel-content');
        this.closeBtn = this.panel.querySelector('.sa-faq-drawer__close');
      }

      // 2. Bind events
      this.querySelectorAll('.sa-faq-drawer__trigger').forEach((btn) => {
        btn.addEventListener('click', this.onItemClick);
      });

      if (this.closeBtn) this.closeBtn.addEventListener('click', this.onCloseClick);
      if (this.overlay) this.overlay.addEventListener('click', this.onOverlayClick);
      document.addEventListener('keydown', this.onKeyDown);

      // 3. Teleport to body to avoid z-index traps
      // Copy CSS variables that might be set on the host
      const fontSize = this.style.getPropertyValue('--faq-font-size');
      if (this.panel && fontSize) {
        this.panel.style.setProperty('--faq-font-size', fontSize);
      }

      if (this.overlay) document.body.appendChild(this.overlay);
      if (this.panel) document.body.appendChild(this.panel);
    }

    disconnectedCallback() {
      // Remove event listeners
      this.querySelectorAll('.sa-faq-drawer__trigger').forEach((btn) => {
        btn.removeEventListener('click', this.onItemClick);
      });
      if (this.closeBtn) this.closeBtn.removeEventListener('click', this.onCloseClick);
      if (this.overlay) this.overlay.removeEventListener('click', this.onOverlayClick);
      document.removeEventListener('keydown', this.onKeyDown);

      // Remove from body
      if (this.overlay && this.overlay.parentNode === document.body) {
        document.body.removeChild(this.overlay);
      }
      if (this.panel && this.panel.parentNode === document.body) {
        document.body.removeChild(this.panel);
      }
    }

    onItemClick(e) {
      const trigger = e.currentTarget;
      const row = trigger.closest('.sa-faq-drawer__row');
      if (!row) return;

      const titleEl = row.querySelector('.sa-faq-drawer__row-title');
      const contentHolder = row.querySelector('.sa-faq-drawer__row-content');
      const title = titleEl ? titleEl.textContent : '';
      const html = contentHolder ? contentHolder.innerHTML : '';
      const linkColor = contentHolder ? contentHolder.getAttribute('data-link-color') : null;

      if (this.titleEl) this.titleEl.textContent = title || '';
      if (this.contentEl) this.contentEl.innerHTML = html || '';
      if (this.contentEl) {
        if (linkColor) {
          this.contentEl.style.setProperty('--faq-link-color', linkColor);
        } else {
          this.contentEl.style.removeProperty('--faq-link-color');
        }
      }

      this.open();
    }

    onCloseClick() { this.close(); }
    onOverlayClick() { this.close(); }
    onKeyDown(ev) { if (ev.key === 'Escape') this.close(); }

    open() {
      // Toggle class on the elements directly
      if (this.panel) {
        this.panel.classList.add('is-open');
        this.panel.setAttribute('aria-hidden', 'false');
      }
      if (this.overlay) {
        this.overlay.classList.add('is-open');
      }
      // Also add class to host for potential other styling needs (though less useful now)
      this.classList.add('sa-faq-drawer--open');
    }

    close() {
      if (this.panel) {
        this.panel.classList.remove('is-open');
        this.panel.setAttribute('aria-hidden', 'true');
      }
      if (this.overlay) {
        this.overlay.classList.remove('is-open');
      }
      this.classList.remove('sa-faq-drawer--open');
      
      if (this.contentEl) this.contentEl.style.removeProperty('--faq-link-color');
    }
  }

  customElements.define('sa-faq-drawer', SaFaqDrawer);
})();
